import { Routes, Route } from "react-router-dom";
import CoreLogs from "./CoreLogs";
import CoreLogDetails from "./CoreLogDetails";

const index = () => {
	return (
		<Routes>
			<Route index element={<CoreLogs />} />
			<Route path='/:id/details' element={<CoreLogDetails />} />
		</Routes>
	);
};

export default index;
